import { render, staticRenderFns } from "./_Description.vue?vue&type=template&id=77edddf1&scoped=true&"
import script from "./_Description.vue?vue&type=script&lang=js&"
export * from "./_Description.vue?vue&type=script&lang=js&"
import style0 from "./_Description.vue?vue&type=style&index=0&id=77edddf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77edddf1",
  null
  
)

export default component.exports